import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSystemConfig, useSystemLogo } from "../../context/systemConfigContext";
import { ReactComponent as CalendarBlankIcon } from "./icons/calendar-blank.svg";
import { ReactComponent as ClockIcon } from "./icons/clock.svg";
import { ReactComponent as StethoscopeIcon } from "./icons/stethoscope.svg";

export default function CitaConfirmadaPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const { logo } = useSystemLogo();
    const { config } = useSystemConfig();

    const patientName = location.state?.patientName ?? "Camila Figueredo";
    const doctorName = location.state?.doctor?.name ?? "Dr. Carlos Mendoza";
    const doctorSpecialty =
        location.state?.doctor?.specialty ?? "Cardiología";

    const reservedDoctor =
        location.state?.doctor?.name ??
        location.state?.reservedDoctor ??
        "Dr. Rodrigo Valdez";
    const reservedCenter =
        config?.hospitalName ?? location.state?.reservedCenter ?? "Centro Láser";
    const dateLabel = location.state?.dateLabel ?? "Lunes 23 de febrero";
    const timeLabel = location.state?.timeLabel ?? "08:00 hs";

    return (
        <div className="min-h-screen bg-[#F1F1FE] flex flex-col items-center justify-center px-4 py-8 font-poppins">
            <div className="w-full max-w-sm">
                <div className="flex justify-center mb-7">
                    <img className="h-auto w-44" src={logo} alt="Logo" />
                </div>

                <div className="bg-white rounded-2xl shadow-sm px-6 py-7">
                    <h1 className="text-center text-[24px] font-semibold text-[#465FFF] tracking-[0.5px]">
                        ¡Cita Confirmada!
                    </h1>

                    <p className="mt-4 text-sm text-[#667085] tracking-[0.3px]">
                        Hola <span className="font-semibold text-[#000000]">{patientName}</span>
                        {" "}
                        <span aria-hidden>👋🏻</span>
                    </p>

                    <p className="mt-2 text-sm text-[#667085] leading-5">
                        Tu turno con el{" "}
                        <span className="font-semibold text-[#000000]">{reservedDoctor}</span>,
                        {" "}en el{" "}
                        <span className="font-semibold text-[#000000]">{reservedCenter}</span>, está reservado
                        temporalmente.
                    </p>

                    <div className="mt-5 bg-[#E3E2FF] border border-[#ECECFF] rounded-xl px-4 py-4">
                        <div className="text-center text-lg font-medium text-[#465FFF]">
                            Resumen de tu Cita
                        </div>

                        <div className="mt-4 flex items-start gap-3">
                            <div className="h-10 w-10 rounded-full bg-[#EFEFFF] flex items-center justify-center flex-shrink-0">
                                <StethoscopeIcon className="h-6 w-6" />
                            </div>
                            <div className="flex-1 min-w-0">
                                <div className="text-base font-medium text-[#000000] break-words">
                                    {doctorName}
                                </div>
                                <div className="text-sm text-[#465FFF]">
                                    {doctorSpecialty}
                                </div>
                            </div>
                        </div>

                        <div className="mt-4 h-px w-full bg-[#E6E6E6]" />

                        <div className="mt-4 flex items-start gap-3">
                            <div className="h-10 w-10 rounded-full bg-[#EFEFFF] flex items-center justify-center flex-shrink-0">
                                <CalendarBlankIcon className="h-6 w-6" />
                            </div>
                            <div className="flex-1">
                                <div className="text-base font-medium text-[#000000]">
                                    {dateLabel}
                                </div>
                                <div className="text-sm text-[#465FFF] flex items-center gap-2">
                                    <ClockIcon className="h-5 w-5" />
                                    <span>{timeLabel}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <button
                        type="button"
                        onClick={() => navigate("/reserve/select-doctor")}
                        className="mt-6 w-full rounded-lg bg-[#465FFF] text-white font-medium py-3 flex items-center justify-center"
                    >
                        Agendar otra cita
                    </button>

                    <button
                        type="button"
                        onClick={() => navigate("/reserve")}
                        className="mt-3 w-full rounded-lg bg-[#EDEFF2] text-[#465FFF] font-medium py-3 flex items-center justify-center"
                    >
                        Volver al inicio
                    </button>
                </div>
            </div>
        </div>
    );
}
